import React from 'react';

import { token } from '@atlaskit/tokens';
import Icon from '@atlaskit/icon';
import type { GlyphProps } from '@atlaskit/icon/types';

const starSvg = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.1276 15.39C11.948 15.39 11.7693 15.3348 11.6156 15.2251L8 12.6322L4.38444 15.2251C4.07644 15.4455 3.66311 15.4455 3.35689 15.2215C3.05067 14.9997 2.92178 14.606 3.03644 14.2464L4.38489 9.89439L0.801777 7.36951C0.497333 7.14506 0.370666 6.7504 0.48711 6.3904C0.604444 6.03128 0.938666 5.78728 1.31644 5.78462L5.75422 5.77795L7.16711 1.53395C7.28622 1.17439 7.62178 0.932617 8 0.932617C8.37822 0.932617 8.71378 1.17484 8.83333 1.53395L10.2222 5.77795L14.6827 5.78462C15.0618 5.78728 15.3964 6.03173 15.5124 6.3904C15.6293 6.7504 15.5027 7.14506 15.1978 7.36951L11.6147 9.89439L12.9631 14.2464C13.0787 14.606 12.9484 14.9997 12.6431 15.2215C12.4889 15.3344 12.3084 15.39 12.1276 15.39Z"
			fill={token('color.background.accent.orange.subtle', '#FFAC33')}
		/>
	</svg>
);

export const MyTemplatesStarIcon = (props: GlyphProps) => <Icon glyph={starSvg} {...props} />;
